<template>
    <div class="home">
        <img src="../static/homebg.png" class="homebg" alt="">
        <img src="../static/title.png" class="title" alt="">
        <p class="words">
            欢乐过大年，金彩云特别推出“金彩出马”系列活动，祝您马年春节金彩不断、福气不停！
        </p>
        <div v-if="start">
            <img src="../static/tobottom.gif" class="tobottom" alt="">
            <img src="../static/hands.png" class="hands" @click="toactivity(1)" alt="">
            <img src="../static/but1.png" class="but1" @click="toactivity(1)"  alt="">
            <img src="../static/but2.png" class="but2" @click="toactivity(2)"  alt="">
            <img src="../static/but3.png" class="but3" @click="toactivity(3)"  alt="">
            <img src="../static/but4.png" class="but4" @click="toactivity(4)"  alt="">
            <img src="../static/but5.png" class="but5" @click="toactivity(5)"  alt="">
            <img src="../static/but6.png" class="but6" @click="toactivity(6)"  alt="">
            <img src="../static/but7.png" class="but7" @click="toactivity(7)"  alt="">
            <img src="../static/but8.png" class="but8" @click="toactivity(8)"  alt="">
            <img src="../static/but9.png" class="but9" @click="toactivity(9)"  alt="">
            <img src="../static/but10.png" class="but10" @click="toactivity(10)"  alt=""></img>
        </div>

    </div>
</template>

<script>

export default {
    data() {
        return {
            start: false
        }
    },
    methods: {
        jump(url) {
            var a = document.createElement("a");
            a.setAttribute("target", "_blank");
            a.setAttribute("href", url);
            a.click();
        },
        toactivity(a){
            if (a==1) {
                this.jump("https://jinhua.y-h5.iyunxh.com/module-collect-card/home/home?hide_back=1&id=12207546")  //金彩出马·马上集福
            }else if(a==2){
                this.jump("https://share.jcy.jinhua.com.cn/c/260213/TOP93dZn8B4PuFfHrx.html?id=1869820")  //金彩出马·马上添彩(好彩头专题)
            }else if(a==3){
                this.jump("https://jinhua.y-h5.iyunxh.com/module-stepsport/home/home?hide_back=1&id=11908876")  //金彩出马·马上康健
            }else if(a==4){
                this.jump("https://jinhua.y-h5.iyunxh.com/module-lottery/home/home?hide_back=1&id=f38310301801ba1cfe2c08")  //金彩出马·马上来财
            }else if(a==5){
                this.jump("https://jinhua.y-h5.iyunxh.com/module-lottery/home/home?hide_back=1&id=518b103018049d05831e08")  //金彩出马·马上转运
            }else if(a==6){
                this.jump("https://jinhua.y-h5.iyunxh.com/games/module-fruit-crush/home/home?hide_back=1&id=12606920")  //金彩出马·马上有趣
            }else if(a==7){
                this.jump("https://jinhua.y-h5.iyunxh.com/module-lottery/home/home?hide_back=1&id=ca7e1030180551561cb808")  //金彩出马·马上有奖
            }else if(a==8){
                this.jump("https://jinhua.y-h5.iyunxh.com/module-supertopic/home/home?hide_back=1&id=10509061")  //金彩出马·马上有戏
            }else if(a==9){
                this.jump("https://jinhua.y-h5.iyunxh.com/dl/iVnuk")  //金彩出马·马上有喜
            }else if(a==10){
                this.jump("https://share.jcy.jinhua.com.cn/c/260214/TOPjJCpUHzUjdnI7pR.html?id=1870267")  //金彩出马·马上金彩----金彩主理人（新春特别节目）
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.start = true
        }, 3000);
    },
}
</script>

<style lang="less">
.home {
    width: 100%;
    height: 100%;
    position: relative;

    .homebg {
        width: 100%;
        display: block;


    }

    .title {
        position: absolute;
        width: 320px;
        top: 50px;
        left: 30px;
        animation: title_ani 2s ease 1 forwards;

        @keyframes title_ani {
            0% {

                transform: scale(0);

            }

            100% {

                transform: scale(1);
            }
        }
    }

    .words {
        position: absolute;
        width: 375px;
        text-indent: 2em;
        top: 270px;
        padding-left: 30px;
        padding-right: 30px;
        box-sizing: border-box;
        font-size: 18px;
        text-align: justify;
        color: #ffffff;
        animation: words_ani 3s ease 1 forwards;

        @keyframes words_ani {
            0% {

                opacity: 0;

            }

            50% {

                opacity: 0;

            }

            100% {

                opacity: 1;
            }
        }

    }

    .tobottom {
        position: absolute;
        width: 40px;
        right: 10px;
        top: 450px;
    }

    .but1 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 400px;
    }

    .hands {
        position: absolute;
        width: 40px;
        left: 290px;
        top: 420px;
        z-index: 2;
        animation: turn 1s linear infinite;

        @keyframes turn {
            0% {
                transform: scale(1);
            }


            50% {
                transform: scale(1.1);
            }

            100% {
                transform: scale(1);
            }
        }
    }

    .but2 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 470px;
    }

    .but3 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 540px;
    }

    .but4 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 610px;
    }

    .but5 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 680px;
    }

    .but6 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 750px;
    }

    .but7 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 820px;
    }

    .but8 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 890px;
    }

    .but9 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 960px;
    }

    .but10 {
        position: absolute;
        width: 255px;
        left: 60px;
        top: 1030px;
    }
}
</style>